(function () {
  "use strict";

  var DRAG_THRESHOLD = 5;

  function getMaxScroll(viewport) {
    return Math.max(0, viewport.scrollWidth - viewport.clientWidth);
  }

  function scrollToSlideStart(viewport, slide, smooth) {
    var v = viewport.getBoundingClientRect();
    var s = slide.getBoundingClientRect();
    var delta = s.left - v.left + viewport.scrollLeft;
    viewport.scrollTo({ left: delta, behavior: smooth ? "smooth" : "auto" });
  }

  function scrollToPage(viewport, slides, dotCount, pageIndex, smooth) {
    if (pageIndex >= dotCount - 1 || !slides.length) {
      viewport.scrollTo({ left: getMaxScroll(viewport), behavior: smooth ? "smooth" : "auto" });
      return;
    }
    var slideIndex = Math.min(pageIndex, slides.length - 1);
    scrollToSlideStart(viewport, slides[slideIndex], smooth);
  }

  function scrollLeftToPageIndex(viewport, slides, dotCount) {
    var maxScroll = getMaxScroll(viewport);
    if (maxScroll <= 0) return 0;
    var current = viewport.scrollLeft;
    var bestIdx = 0;
    var bestDist = Infinity;
    var i;
    for (i = 0; i < dotCount; i++) {
      var target = i >= dotCount - 1 ? maxScroll : slides[Math.min(i, slides.length - 1)].offsetLeft;
      var dist = Math.abs(current - target);
      if (dist < bestDist) {
        bestDist = dist;
        bestIdx = i;
      }
    }
    return bestIdx;
  }

  function throttleRaf(fn) {
    var scheduled = false;
    return function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        fn();
      });
    };
  }

  function initCarousel(root) {
    var viewport = root.querySelector(".ck-custom-carousel__viewport");
    var track = root.querySelector(".ck-custom-carousel__track");
    var pageDots = root.querySelector("page-dots");
    if (!viewport || !track || !pageDots) return;

    var slides = Array.from(track.querySelectorAll(".ck-custom-carousel__slide"));
    var dotCount = pageDots.querySelectorAll("button").length;
    if (dotCount <= 1 || slides.length === 0) return;

    var programmaticScroll = false;
    var syncDots = throttleRaf(function () {
      if (programmaticScroll) return;
      var idx = scrollLeftToPageIndex(viewport, slides, dotCount);
      if (pageDots.selectedIndex !== idx) pageDots.selectedIndex = idx;
    });

    function scrollToPageIndex(index, smooth) {
      programmaticScroll = true;
      scrollToPage(viewport, slides, dotCount, index, smooth);
      if (pageDots.selectedIndex !== index) pageDots.selectedIndex = index;
      window.setTimeout(function () {
        programmaticScroll = false;
        syncDots();
      }, smooth ? 420 : 0);
    }

    root.addEventListener("page-dots:changed", function (event) {
      var idx = event.detail && typeof event.detail.index === "number" ? event.detail.index : 0;
      scrollToPageIndex(idx, true);
    });

    viewport.addEventListener("scroll", syncDots, { passive: true });

    var prefersCoarse = window.matchMedia("(hover: none)").matches;

    viewport.addEventListener("wheel", function (e) {
      if (prefersCoarse) return;
      var maxScroll = getMaxScroll(viewport);
      if (maxScroll <= 0) return;
      var dx = e.deltaX;
      var dy = e.deltaY;
      if (Math.abs(dy) > Math.abs(dx)) dx = dy;
      if (dx === 0) return;
      e.preventDefault();
      var next = viewport.scrollLeft + dx;
      viewport.scrollLeft = Math.max(0, Math.min(next, maxScroll));
    }, { passive: false });

    var dragPointerId = null;
    var dragStartX = 0;
    var dragStartScroll = 0;
    var dragMoved = false;
    var pointerCaptured = false;

    viewport.addEventListener("pointerdown", function (e) {
      if (e.pointerType !== "mouse") return;
      if (prefersCoarse) return;
      dragPointerId = e.pointerId;
      dragStartX = e.clientX;
      dragStartScroll = viewport.scrollLeft;
      dragMoved = false;
      pointerCaptured = false;
    });

    viewport.addEventListener("pointermove", function (e) {
      if (e.pointerId !== dragPointerId || e.pointerType !== "mouse") return;
      var dx = e.clientX - dragStartX;
      if (!dragMoved && Math.abs(dx) > DRAG_THRESHOLD) {
        dragMoved = true;
        viewport.classList.add("is-dragging");
        if (!pointerCaptured) {
          pointerCaptured = true;
          try {
            viewport.setPointerCapture(e.pointerId);
          } catch (_) {
            pointerCaptured = false;
          }
        }
      }
      if (dragMoved) {
        e.preventDefault();
        var maxScroll = getMaxScroll(viewport);
        viewport.scrollLeft = Math.max(0, Math.min(dragStartScroll - dx, maxScroll));
      }
    });

    function endDrag(e) {
      if (e.pointerId !== dragPointerId) return;
      var didDrag = dragMoved;
      dragPointerId = null;
      viewport.classList.remove("is-dragging");
      if (pointerCaptured) {
        try {
          viewport.releasePointerCapture(e.pointerId);
        } catch (_) {}
        pointerCaptured = false;
      }
      if (didDrag) {
        viewport.addEventListener(
          "click",
          function (clickEv) {
            clickEv.preventDefault();
            clickEv.stopPropagation();
          },
          { capture: true, once: true }
        );
      }
    }

    viewport.addEventListener("pointerup", endDrag);
    viewport.addEventListener("pointercancel", endDrag);

    if (typeof ResizeObserver !== "undefined") {
      var ro = new ResizeObserver(function () {
        syncDots();
      });
      ro.observe(viewport);
    }

    syncDots();
  }

  function init() {
    document.querySelectorAll(".ck-custom-carousel").forEach(initCarousel);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();
